import React from 'react';
import { UserContext } from '../../userContext';
export const useUserData = () => {
    const userContext = React.useContext(UserContext);
    return userContext;
};
//# sourceMappingURL=useUserData.js.map